import { $, $$ } from '../_utils'

class RegisterValidateService {
  static handleSubmit = event => {
    event.preventDefault()
    if (this.validateFields()) this.form.submit()
  }

  static validateFields = () => {
    this.setRequiredFields()
    this.getEmtyFields()
    this.generateErrors()

    if ($('#userEmail').value && this.isEmailCorrect($('#userEmail').value))
      this.removeFromErrors($('#userEmail'))
    else if ($('#userEmail').value && !this.isEmailCorrect($('#userEmail').value))
      this.addToErrors('Adres e-mail powinien zawierać znak @', $('#userEmail'))

    if ($('#userKamsoftNumber').value && isNaN(Number($('#userKamsoftNumber').value)))
      this.addToErrors('To pole musi zawierać liczbę', $('#userKamsoftNumber'))
    if ($('#pharmacyKamsoftNumber').value && isNaN(Number($('#pharmacyKamsoftNumber').value)))
      this.addToErrors('To pole musi zawierać liczbę', $('#pharmacyKamsoftNumber'))

    if (this.errors && this.errors.length !== 0) this.setErrors()
    this.markCorrect()
    this.scrollToFirstError()
    return this.errors.length === 0
  }

  static scrollToFirstError = () => {
    if (document.querySelectorAll('.invalid')[0]) {
      document
        .querySelectorAll('.invalid')[0]
        .scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  static setRequiredFields = () => {
    this.requiredFields = this.formInputs.filter(this.isRequired)
  }

  static setErrors = () => {
    this.errors.forEach(error => {
      if (error.element.parentNode.className.includes('invalid')) {
        if ($('.error', error.element.parentNode))
          $('.error', error.element.parentNode).innerHTML = error.text
      } else if (error.element.parentNode.className.includes('valid')) {
        error.element.parentNode.classList.remove('valid')
        error.element.parentNode.classList.add('invalid')
        if ($('.error', error.element.parentNode))
          $('.error', error.element.parentNode).innerHTML = error.text
      } else {
        error.element.parentNode.classList.add('invalid')
        if ($('.error', error.element.parentNode))
          $('.error', error.element.parentNode).innerHTML = error.text
      }
    })
  }

  static handleclassChange = (type, element, classString) => {
    if (type === 'add' && element) element.classList.add(classString)
    else if (element) element.classList.remove(classString)
  }

  static markCorrect = () => {
    this.formInputs.forEach(input => {
      if (this.errors && !this.errors.find(error => error.element.id === input.id))
        this.setValidClass(input)
    })
  }

  static setValidClass = element => {
    if (element.parentNode.className.includes('invalid')) {
      element.parentNode.classList.remove('invalid')
    }
    if (!element.parentNode.className.includes('valid')) element.parentNode.classList.add('valid')
  }

  static isEmpty = element => {
    if (element.type === 'checkbox') {
      return !element.checked
    } else return element && !element.value
  }

  static getEmtyFields = () => {
    if (this.requiredFields)
      this.emptyFields = this.requiredFields.filter(RegisterValidateService.isEmpty)
  }
  static generateErrors = () => {
    this.errors = []
    this.errors = this.emptyFields.map(element => {
      return { text: 'To pole jest wymagane', element: element }
    })
  }

  static isChecked = element => {
    return element && !element.checked
  }
  static isRequired = element => {
    return element && element.required
  }
  static addSubmitListener = () => {
    this.form.addEventListener('submit', this.handleSubmit)
  }

  static addFocusListeners = () => {
    this.formInputs.forEach(input => {
      input.addEventListener('focus', () => this.removeValidationClasses(input))
    })
  }
  static addSelectFocusListener = () => {
    $('.js-role-select').addEventListener('click', () =>
      this.removeValidationClasses($('.js-role-select'))
    )
  }
  static removeValidationClasses = element => {
    if (element.className.includes('js-role-select')) {
      if (element.className.includes('valid')) element.classList.remove('valid')
      if (element.className.includes('invalid')) element.classList.remove('invalid')
    } else {
      if (element && element.parentNode && element.parentNode.className.includes('valid'))
        element.parentNode.classList.remove('valid')
      if (element && element.parentNode && element.parentNode.className.includes('invalid'))
        element.parentNode.classList.remove('invalid')
    }
  }
  static init = () => {
    this.form = $('#register')
    this.formItems = $$('.input-wrapper')
    this.formInputs = $$('input')
    this.addSubmitListener()
    this.addFocusListeners()
    this.addSelectFocusListener()
  }
  static isEmailCorrect(text) {
    const pattern = /\S+@\S+\.\S+/
    return pattern.test(text)
  }
  static removeFromErrors = element => {
    this.errors.filter(error => element.id !== error.element.id)
  }
  static addToErrors = (text, element) => {
    if (
      this.errors.find(error => {
        return element.id === error.element.id
      })
    )
      this.errors.forEach(error => {
        if (error.element.id === element.id && text) error.text = text
      })
    else {
      this.errors.push({ text: text, element: element })
    }
  }
}

const registerForm = $('#register')

window.addEventListener('DOMContentLoaded', () => {
  if (!registerForm) return
  RegisterValidateService.init()
})
